<mat-chip-listbox [selectable]="selectable" [ngClass]="pillListCss">
  <mat-chip-option
    [ngClass]="pillCss"
    [selectable]="selectable"
    [disabled]="disabled"
    [matTooltipDisabled]="!option.tooltip"
    [matTooltip]="option.tooltip"
    [selected]="option.value === this.control.value"
    *ngFor="let option of availableOptionsValue"
    [value]="option.value"
    (click)="selectOption(option.value)">
    {{ option.label }}
  </mat-chip-option>
</mat-chip-listbox>
